import { useEffect, useState } from "react";
import { NavLink, Outlet, Link, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Icon } from "./ui";
import { Toaster } from "sonner";
import "./pd.css";

const LINKS = [
  { to: "/property-desk", label: "Desk", end: true },
  { to: "/property-desk/explore", label: "Exceptional Properties" },
  { to: "/property-desk/curated", label: "Vinci Curated" },
  { to: "/property-desk/cities", label: "Cities" },
  { to: "/property-desk/requirements", label: "Requirements" },
  { to: "/property-desk/insights", label: "Insights" },
];

export default function PDLayout() {
  const { user, api } = useAuth();
  const loc = useLocation();
  const [me, setMe] = useState(null);
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => { if (user) api.get("/property-desk/me").then((r) => setMe(r.data)).catch(() => {}); }, [user, api]);
  useEffect(() => { window.scrollTo({ top: 0 }); setOpen(false); }, [loc.pathname]);
  useEffect(() => { const f = () => setScrolled(window.scrollY > 40); window.addEventListener("scroll", f); return () => window.removeEventListener("scroll", f); }, []);

  const partnerLabel = me?.can_submit ? "Submit for Consideration" : "Become a Partner";
  const loginTo = `/login?next=${encodeURIComponent(loc.pathname)}`;
  return (
    <div className="pd" data-testid="property-desk">
      <Toaster position="bottom-right" theme="dark" toastOptions={{ style: { background: "#111110", color: "#F5F5F0", border: "1px solid rgba(201,168,76,0.35)" } }} />
      <header className={`fixed top-0 inset-x-0 z-40 transition-colors duration-500 ${scrolled || open ? "bg-[#0A0A0A]/90 backdrop-blur-md border-b pd-line" : "bg-gradient-to-b from-[#0A0A0A]/85 to-transparent"}`} data-testid="pd-nav">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 h-20 flex items-center justify-between gap-6">
          <Link to="/property-desk" className="flex items-center gap-3 shrink-0" data-testid="pd-brand">
            <Icon.Diamond size={18} className="text-[#C9A84C]" />
            <span className="pd-serif text-lg xl:text-xl tracking-[0.16em] uppercase whitespace-nowrap">Vinci <span className="pd-gold">Property Desk</span></span>
          </Link>
          <nav className="hidden lg:flex items-center gap-6 xl:gap-9 whitespace-nowrap">
            {LINKS.map((l) => <NavLink key={l.to} to={l.to} end={l.end} className={({ isActive }) => `pd-nav-link ${isActive ? "active" : ""}`} data-testid={`pd-nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}>{l.label}</NavLink>)}
          </nav>
          <div className="hidden lg:flex items-center gap-5 shrink-0 whitespace-nowrap">
            {user && <Link to="/property-desk/interests" className="pd-nav-link" data-testid="pd-nav-interests">Interests</Link>}
            <Link to="/" className="pd-nav-link" data-testid="pd-back-platform">← Platform</Link>
            <Link to={user ? (me?.can_submit ? "/property-desk/submit" : "/property-desk/partner") : `/login?next=${encodeURIComponent(loc.pathname)}`} className="pd-cta !py-3 !px-5 !text-[10px]" data-testid="pd-nav-cta">{user ? (me?.can_submit ? "Submit" : "Partner") : "Member Login"}</Link>
          </div>
          <button className="lg:hidden pd-gold" onClick={() => setOpen((o) => !o)} aria-label="Menu" data-testid="pd-menu-toggle">{open ? <Icon.Close size={22} /> : <Icon.Sliders size={22} />}</button>
        </div>
        {open && (
          <div className="lg:hidden border-t pd-line bg-[#0A0A0A] px-6 py-8 flex flex-col gap-6 pd-enter">
            {LINKS.map((l) => <NavLink key={l.to} to={l.to} end={l.end} className={({ isActive }) => `pd-nav-link text-base ${isActive ? "active" : ""}`}>{l.label}</NavLink>)}
            <Link to={user ? (me?.can_submit ? "/property-desk/submit" : "/property-desk/partner") : loginTo} className="pd-cta justify-center">{user ? partnerLabel : "Member Login"}</Link>
            <Link to="/" className="pd-nav-link">← Back to Platform</Link>
          </div>
        )}
      </header>
      <main key={loc.pathname} className="pd-enter"><Outlet context={{ me, refreshMe: () => api.get("/property-desk/me").then((r) => setMe(r.data)).catch(() => {}) }} /></main>
      <footer className="border-t pd-line mt-20">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-16 flex flex-col md:flex-row justify-between gap-8">
          <div><div className="pd-label mb-3">Vinci Property Desk</div><p className="pd-serif text-2xl">Exceptional Properties. Verified Network.</p></div>
          <p className="pd-muted text-xs tracking-[0.18em] uppercase max-w-sm leading-loose">Exclusively for Vinci verified members and Verified Property Partners. Every property is reviewed by our desk before presentation.</p>
        </div>
      </footer>
    </div>
  );
}
